export default __webpack_public_path__ + "static/media/back_default.4d510f1e.svg";